import { RuleId, RuleLevel } from '../../../types-v2';
export const visualIndicatorsRule = {
  checker: _ref => {
    let {
      visualFocusDisabled
    } = _ref;
    const visualIndicatorsStatus = visualFocusDisabled ? 'failed' : 'passed';
    return {
      status: visualIndicatorsStatus
    };
  },
  level: RuleLevel.Site,
  ruleId: RuleId.VISUAL_INDICATORS
};
//# sourceMappingURL=visual-indicators.js.map